import React from 'react';
import moment from 'moment';
//
import Col from 'components/common/Col';
import Row from 'components/common/Row';
import Button from 'components/common/Button';
import Title from 'components/text/Title';
import Caption from 'components/text/Caption';

const DataRow = ({ label, value }) => {
  return (
    <Col xs={24}>
      <Title>
        {label}: <Caption style={{ color: '#999' }}>{value}</Caption>
      </Title>
    </Col>
  );
};

const ModalContent = ({ selectedEvent, onEdit, withProfileBtn, profileBtnLabel, onProfileBtnClick }) => {
  if (!selectedEvent) {
    return null;
  }

  const { title, sessionType, sessionDate, sessionTime, description } = selectedEvent;

  return (
    <div style={{ minHeight: 175, display: 'flex', flexDirection: 'column' }}>
      <Row type="flex" align="middle" justify="center">
        <DataRow label="Title" value={title || ''} />
        <DataRow label="Category" value={sessionType.title || ''} />
        <DataRow
          label="Date"
          value={(sessionDate && moment.utc(selectedEvent.sessionDate).format('YYYY-MM-DD')) || ''}
        />
        <DataRow label="Time" value={sessionTime || ''} />
        <DataRow label="Description" value={description || ''} />
      </Row>
      <Row type="flex" align="middle" justify="flex-end">
        <Button style={{ marginRight: 10 }} icon="edit" type="dashed" onClick={onEdit} size="large" className="mt2">
          EDIT
        </Button>
        {withProfileBtn && (
          <Button type="primary" onClick={onProfileBtnClick} size="large" className="mt2">
            {profileBtnLabel}
          </Button>
        )}
      </Row>
    </div>
  );
};

export default ModalContent;



// WEBPACK FOOTER //
// ./src/components/common/NedCalendar/ModalContent/index.js